// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore , doc, setDoc }  from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyC_xOFLQgRV_olhhD9UAUqmzS92RgFl8Qo",
  authDomain: "naayatrade-5e307.firebaseapp.com",
  projectId: "naayatrade-5e307",
  storageBucket: "naayatrade-5e307.appspot.com",
  messagingSenderId: "348820321390",
  appId: "1:348820321390:web:de03b6cee0a3599247227f",
  measurementId: "G-76WGNV9GY0"
};

// Initialize Firebase
export function firebaseInitialize(){
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  const db = getFirestore(app);         
  const auth = getAuth(app);
  const provider = new GoogleAuthProvider();
} 
// export {db ,auth, provider, doc, setDoc };